<template>
  <v-card>
    <v-card-title>
      {{ $t('title-payment') }}
    </v-card-title>
    <v-card-text>
      <div v-if="$account.current.customer.payment_method">
        {{ $t('payment-method') }}
        <span v-if="$account.current.customer.payment_method.type === 'card'">{{ $t('payment-method-card') }}</span>
        {{ $account.current.customer.payment_method.card.brand.toUpperCase() }}<br/>
        {{ $t('card-number') }} XXXX XXXX XXXX {{ $account.current.customer.payment_method.card.last4 }}<br/>
        {{ $t('card-expiration') }} {{ $account.current.customer.payment_method.card.exp_month }} /
        {{ $account.current.customer.payment_method.card.exp_year }}
      </div>
      <div v-else-if="!$account.current.customer">
        {{ $t('billing-details-empty') }}
      </div>
      <div v-else>
        {{ $t('payment-method-empty') }}
      </div>
    </v-card-text>
    <v-card-actions>
      <v-btn
        @click="$ui.openDialog('edit_customer_payment_method')"
        color="primary"
        text
        :disabled="!$account.current.customer">Modifier
      </v-btn>
    </v-card-actions>
  </v-card>
</template>

<script>
export default {
  name: 'ABillingPaymentMethodWidget'
}
</script>

<style scoped>

</style>

<i18n>
{
	"en": {
		"billing-details-empty": "  You must already fill in your billing details before you can link a credit card to your account.",
		"card-expiration": "Expiry:",
		"card-number": "Number:",
		"payment-method": "Type:",
		"payment-method-card": "Bank Card",
		"payment-method-empty": "No payment method.",
		"title-payment": "Payment method"
	},
	"es": {
		"billing-details-empty": "  Ya debe completar sus datos de facturación antes de poder vincular una tarjeta de crédito a su cuenta.",
		"card-expiration": "Expiración:",
		"card-number": "Número:",
		"payment-method": "Tipo:",
		"payment-method-card": "Tarjeta de crédito",
		"payment-method-empty": "Sin método de pago.",
		"title-payment": "Método de pago"
	},
	"fr": {
		"billing-details-empty": "  Vous devez déjà renseigner vos coordonnées de facturation avant de pouvoir lier une carte bancaire à votre compte.",
		"card-expiration": "Expiration: ",
		"card-number": "Numéro: ",
		"payment-method": "Type:",
		"payment-method-card": "Carte Bancaire",
		"payment-method-empty": "Aucun moyen de paiement.",
		"title-payment": "Moyen de paiement"
	},
	"it": {
		"billing-details-empty": "  Devi prima compilare i tuoi dati di fatturazione prima di poter collegare una carta di credito al tuo account.",
		"card-expiration": "Scadenza:",
		"card-number": "Numero:",
		"payment-method": "Tipo:",
		"payment-method-card": "Carta bancaria",
		"payment-method-empty": "Nessun metodo di pagamento.",
		"title-payment": "Metodo di pagamento"
	},
	"pt": {
		"billing-details-empty": "  Deve primeiro preencher os seus dados de faturação antes de poder associar um cartão de crédito à sua conta.",
		"card-expiration": "Expiração:",
		"card-number": "Número:",
		"payment-method": "Tipo:",
		"payment-method-card": "Cartão bancário",
		"payment-method-empty": "Nenhum método de pagamento.",
		"title-payment": "Método de pagamento"
	},
	"pl": {
		"billing-details-empty": "  Musisz najpierw uzupełnić dane do faktury, zanim będziesz mógł powiązać kartę kredytową z kontem.",
		"card-expiration": "Wygaśnięcie:",
		"card-number": "Numer:",
		"payment-method": "Typ:",
		"payment-method-card": "Karta bankowa",
		"payment-method-empty": "Brak metody płatności.",
		"title-payment": "Metoda płatności"
	}
}
</i18n>
